import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { supabase } from "./supabase";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPhoneNumber(phoneNumber?: string | null): string {
  if (!phoneNumber) return "Unknown";
  
  const cleaned = phoneNumber.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return phoneNumber;
}

/**
 * Log a system event or error to the staff_notifications table
 * @param type The type of event ('error', 'system', etc.)
 * @param message The message to log
 * @param customerId Optional customer ID if the event is related to a customer
 */
export async function logSystemEvent(
  type: string, 
  message: string, 
  customerId?: string
): Promise<boolean> {
  try {
    await supabase.rpc('insert_staff_notification', {
      p_type: type,
      p_message: message,
      p_customer_id: customerId || null
    });
    return true;
  } catch (error) {
    console.error('Failed to log system event:', error);
    return false;
  }
}
